<template>
  <div class="with-side-panel">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <div class="d-flex justify-content-between">
            <h6 class="element-header">
              Rechnungslegung
            </h6>
          </div>

          <div class="element-box overflow-hidden">
            <div
                class="custom_responsive_element"
                v-if="companySettings?.privateCoachingEnabled">
              <router-link
                  :to="{ name: 'billingPrivateCoachingPreviewList' }"
                  class="btn btn-primary btn-block"
                  style="padding: 10px">
                Einzelcoaching
              </router-link>
            </div>

            <div
                class="custom_responsive_element"
                v-if="companySettings?.groupCoachingEnabled">
              <router-link
                  :to="{ name: 'billingGroupCoachingPreviewList' }"
                  class="btn btn-primary btn-block"
                  style="padding: 10px">
                Gruppen-maßnahmen
              </router-link>
            </div>

            <div
                class="custom_responsive_element"
                 v-if="companySettings?.socioTherapyCoachingEnabled">
              <router-link
                  :to="{ name: 'billingSocioTherapyCoachingPreviewList' }"
                  class="btn btn-primary btn-block"
                  style="padding: 10px">
                Soziotherapie
              </router-link>
            </div>

            <div
                class="custom_responsive_element"
                v-if="companySettings?.assistedLivingCoachingEnabled">
              <router-link
                  :to="{ name: 'billingAssistedLivingCoachingPreviewList' }"
                  class="btn btn-primary btn-block"
                  style="padding: 10px">
                Betreutes Wohnen
              </router-link>
            </div>

            <div
                class="custom_responsive_element"
                v-if="companySettings?.caseManagementCoachingEnabled">
              <router-link
                  :to="{ name: 'billingCaseManagementCoachingPreviewList' }"
                  class="btn btn-primary btn-block"
                  style="padding: 10px">
                DRV Fallmanagement
              </router-link>
            </div>

            <div
                 class="custom_responsive_element"
                 v-if="companySettings?.privateLearningCoachingEnabled">
              <router-link
                  :to="{ name: 'billingPrivateLearningCoachingPreviewList' }"
                  class="btn btn-primary btn-block"
                  style="padding: 10px">
                Private Weiterbildung
              </router-link>
            </div>

            <div class="custom_responsive_element">
              <router-link
                  :to="{ name: 'billingSpecialCaseForm' }"
                  class="btn btn-primary btn-block"
                  style="padding: 10px">
                Ausserordentliche
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <Sidebar></Sidebar>
    </div>
  </div>
</template>

<script setup>
import Sidebar from '@/components/FormSidebar.vue';
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";
import {computed} from "vue";

const piniaCompanySettingsState = piniaCompanySettingsStore()
const companySettings = computed(() => piniaCompanySettingsState.companySettings)

</script>

<style scoped>

</style>